import { Routes } from '@angular/router';
import { routerLinks } from '@helpers/shared/router-links.const';
import { GoHomeComponent } from './layouts/go-home.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { DropAuthGuard } from './auth/drop-auth.guard';
import { AuthGuard } from './auth/auth.guard';
import { HlrPaths } from '@helpers/shared/hlr-paths';

export const APP_ROUTES: Routes = [
	{
		path: HlrPaths.SignIn,
		loadComponent: () =>
			import('./layouts/sign-in-layout/sign-in-layout.component').then((m) => m.SignInLayoutComponent),
		canActivate: [DropAuthGuard],
		data: { animationState: 'SignInLayoutComponent' }
	},
	{
		path: '',
		component: MainLayoutComponent,
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		data: { animationState: 'MainLayoutComponent' },
		children: [
			{ path: 'reference_books', redirectTo: 'reference_books/currencies', pathMatch: 'full' },
			{ path: 'dipping', redirectTo: 'dipping/rules', pathMatch: 'full' },
			{ path: 'administration', redirectTo: 'administration/users', pathMatch: 'full' },

			{ path: '', component: GoHomeComponent },

			...Object.values(routerLinks)
		]
	},
	{ path: '**', redirectTo: '' }
];
